import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BarraBuscaComponent } from '../shared/barra-busca/barra-busca.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {

  @ViewChild(BarraBuscaComponent) novaMensagem: BarraBuscaComponent;

  filtros = [];
  componenteRef = 'faq';
  perguntas: any;
  paginaAtual: number;
  totalPaginas: number;
  totalItens: number;
  realizouBusca: boolean;
  mensagem?: string;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const { totalPaginas, paginaAtual, itens, totalItens } = data.faq;
      this.totalPaginas = totalPaginas;
      this.paginaAtual = paginaAtual;
      this.perguntas = itens;
      this.totalItens = totalItens;

      if (this.perguntas.length === 0 && this.realizouBusca) {
        this.mensagem = 'Desculpe, não encontramos nenhum resultado compatível com sua busca.';
        this.enviarMensagem(this.mensagem);
      } else {
        this.mensagem = `Total de resultados encontrados ${this.totalItens}`;
      }
    });
  }

  recebeuInput(input: any) {
    this.realizouBusca = true;
    this.router.navigate(['/faq'], {
      queryParams: { query: input.stringBusca },
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/faq'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }


  /**
   * Envia mensagem para o filho.
   */
  enviarMensagem(mensagem: string) {
    this.novaMensagem.alteraMensagem(mensagem);
  }
}
